"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _closeDefault = _interopRequireDefault(require("@teladoc/pulse/icons/close-default.svg"));
var _DismissButtonModule = _interopRequireDefault(require("./DismissButton.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["className", "testAttr", "i18nLabel", "inverse", "onClick"];
/**
 * A component that is only used internally by other Pulse components to centralize UI and functionality
 * for a dismissable button action performed by its parent.
 */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const DismissButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
      className,
      testAttr,
      i18nLabel,
      inverse,
      onClick
    } = _ref,
    attrs = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread(_objectSpread({
    ref: ref,
    className: (0, _cnbuilder.cnb)(_DismissButtonModule.default.root, {
      [_DismissButtonModule.default.inverse]: inverse
    }, className),
    "aria-label": i18nLabel || t('ui:dismissButton.label'),
    "data-testid": testAttr,
    type: "button",
    onClick: onClick
  }, attrs), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeDefault.default, {
      className: _DismissButtonModule.default.icon
    })
  }));
});
DismissButton.defaultProps = {
  testAttr: 'dismiss-button'
};
var _default = exports.default = DismissButton;